<app-colored-background [backgroundColor]="'#03A97F'">
  <app-header
    [title]="locale.currentTranslation.tripInformationHeader"
    [useWhiteFontColor]="true"
    [showProgressIndicator]="false"
    [showClose]="false"
    data-testid="ride-finished-header"
  ></app-header>
  <div data-testid="ride-finished-container">
    <div class="base-content-container" data-testid="ride-finished-content">
      <div class=headline1 style="color: #FFFFFF" data-testid="ride-finished-headline">
        {{ locale.currentTranslation.finishRideInformationHeadline }}
      </div>
      <div class="text-body1" style="color: #FFFFFF" data-testid="ride-finished-text">
        {{ locale.currentTranslation.finishRideInformationText }}
      </div>
    </div>
    <app-finish-box data-testid="ride-finished-finish-box"></app-finish-box>
    <div class="main-button-spacing" data-testid="ride-finished-button-container">
      <button class="main-button" routerLink="/document-upload-overview" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
    </div>
  </div>

  <app-footer data-testid="ride-finished-footer"></app-footer>
</app-colored-background>
